<template>
  <div v-if="this.aupair" class="block text-center">
    <Photo class="m-auto" :src="aupair.profilePhoto" :alt="aupair.firstName" />
    <AuPairName class="text-4xl mt-5 mb-12" :name="aupair.firstName" />
    <FullSummary :aupair="this.aupair" />
    <FullChildCareExperience :aupair="this.aupair" />
    <FullDrivingSkills v-if="aupair.drivingSkills" :aupair="aupair" />
    <FullActivities v-if="aupair.activities" :activities="aupair.activities" />
    <FullNotesForHostFamily
      v-if="aupair.additionalNotesToHF"
      :notes="aupair.additionalNotesToHF"
    />

    <PhotoGallery v-if="aupair.photos" :photos="aupair.photos" />
    <Video v-if="aupair.youtubeVideo" :video="aupair.youtubeVideo" />
  </div>
  <ComponentLoading v-else />
</template>

<script>
import AuPairName from "@/components/AuPairs/AuPairCardItems/AuPairName.vue";
import Photo from "@/components/AuPairs/AuPairCardItems/Photo.vue";
import FullSummary from "@/components/AuPairs/AuPairProfileItems/FullSummary.vue";
import FullChildCareExperience from "@/components/AuPairs/AuPairProfileItems/FullChildCareExperience.vue";
import FullDrivingSkills from "@/components/AuPairs/AuPairProfileItems/FullDrivingSkills.vue";
import FullActivities from "@/components/AuPairs/AuPairProfileItems/FullActivities.vue";
import FullNotesForHostFamily from "@/components/AuPairs/AuPairProfileItems/FullNotesForHostFamily.vue";
import PhotoGallery from "@/components/AuPairs/AuPairProfileItems/PhotoGallery.vue";
import Video from "@/components/AuPairs/AuPairProfileItems/Video.vue";

export default {
  name: "ProfileContainer",
  props: {
    aupair: Object,
  },
  components: {
    AuPairName,
    Photo,
    FullSummary,
    FullChildCareExperience,
    FullDrivingSkills,
    FullActivities,
    FullNotesForHostFamily,
    PhotoGallery,
    Video,
  },
};
</script>

<style></style>
